import {CodeEditor} from "../../stem-core/ui/CodeEditor.jsx";
import type {ExtendedOptions} from "../../stem-core/ui/UIBase";

interface HTMLEditorOptions {
    initialValue?: string;
}

export class HTMLEditor extends CodeEditor {
    declare options: ExtendedOptions<CodeEditor, HTMLEditorOptions>;

    oldInitialValue: string | null = null;

    applyAceOptions() {
        super.applyAceOptions();
        if (this.options.initialValue && this.options.initialValue !== this.oldInitialValue) {
            this.oldInitialValue = this.options.initialValue;
            this.setValue(this.options.initialValue, false);
        }
    }

    addAceChangeListener(callback: (...args: unknown[]) => void) {
        return super.addAceChangeListener((...args: unknown[]) => {
            // Ignore when we're setting these values in code.
            // TODO: This should probably be in CodeEditor. CS Academy does the same thing on the listener side.
            if (!this.apiChange) {
                // In case there's an error in the callback, Ace breaks down
                setTimeout(() => callback(...args));
            }
        });
    }
}
